import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#394a61",
        secondary: '#7d96b5',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
});
